import { defineComponent } from 'vue'
  import { ElMessage } from 'element-plus'
  const showMessage=(type,msg) =>{
    if(type=='success'){
        ElMessage.success({
            message: msg,
            type: 'success',
          })
    }
    else if(type=='error'){
        ElMessage.error({
            message: msg,
            type: 'error',
          })
    }
    else{
        ElMessage({
            message: msg,
            type: 'info',
          })
    }
  } 
  export default showMessage